import { ZepIcon_default } from './chunk-SGEFWXJL.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var ExclamationmarkSmallCircleColorIcon = ZepIcon_default(
  (props) => /* @__PURE__ */ jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm-1 11a1 1 0 1 0 2 0V7a1 1 0 1 0-2 0v6Zm1 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
        fill: "#E9EAF2"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 14a1 1 0 0 1-1-1V7a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1ZM10.5 16.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
        fill: "#7A7B89"
      }
    )
  ] })
);

export { ExclamationmarkSmallCircleColorIcon };
